import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';


const ImportConfirmationDialog = ({ open, onClose }) => {
    // Você pode adicionar mais estados conforme necessário

    const handleClose = () => {
        onClose();
    };

    const handleConfirm = () => {

        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                style: styles.dialogPaper
            }}
        >
            <DialogTitle>
                <div style={styles.circulo}>
                    <CheckIcon style={styles.icone} />
                </div>
            </DialogTitle>
            <DialogContent style={styles.textContent}>
                <p>Funcionários importados com sucesso.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Fechar
                </Button>
                <Link to="/funcionarios" style={{ textDecoration: 'none' }}>
                    <Button color="primary" variant="contained" style={styles.Button}>
                       Ver funcionários
                    </Button>
                </Link>
            </DialogActions>
        </Dialog>
    );
};

export default ImportConfirmationDialog;

const styles = ({
    dialogPaper: {
        borderRadius: '20px',
        alignItems: 'center',
        width: '32em',
        height: '15em',
        overflowY: 'hidden'
    },
    circulo: {
        width: '70px',
        height: '70px',
        borderRadius: '50%',
        border: `2px solid green`, // Cor verde para as bordas
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white', // Cor de fundo branca
    },
    icone: {
        color: 'green', // Cor verde para o ícone
        fontSize: '30px',
    },
    textContent: {
        fontSize: '16px',
        overflowY: 'hidden'
    },
    Button: {
        marginLeft:'20px',
        borderRadius:'15px'
    }
})
